import "./styles.css";
import React from "react";
import { Layout, Space, Typography, Row, Col } from "antd";
import { FacebookFilled, InstagramFilled, WhatsAppOutlined } from "@ant-design/icons";
import { ContentLayout } from "../contentLayout/contentLayout";
import { IMAGES } from "../../constants/images";

const { Text, Link } = Typography;
const { Footer, Content } = Layout;

const colStyle = {
  padding: 10,
};

const linkStyle = {
  fontSize: 14,
  color: "#fff",
};

const socialStyle = {
  fontSize: 26,
  color: "#fff",
};

export const SimpleLayout = ({ children }) => {
  return (
    <ContentLayout>
      <Layout.Header className="page-header">
        <Space size={20} className="header-content">
          <div className="logo-container">
            <img
              style={{ maxHeight: 25, objectFit: "contain" }}
              width={"100%"}
              alt="copérdia"
              src={IMAGES?.logoWhite}
            />
          </div>
        </Space>
      </Layout.Header>
      <Content className="content-page">{children}</Content>
      <RenderFooter />
    </ContentLayout>
  );
};

const RenderFooter = () => {
  return (
    <Footer className="footer-content">
      <Row align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} style={colStyle}>
              <Space direction="vertical" size={4}>
                <img
                  src={"https://statics.coperdia.com.br/portal_colaborador/img/logo-coperdia-large.png"}
                  width={180}
                  style={{ objectFit: "contain", marginBottom: 10 }}
                />

                <Text strong style={linkStyle}>
                  COOPERATIVA DE PRODUÇÃO E CONSUMO CONCÓRDIA – Matriz
                </Text>
                <Text style={linkStyle}>Rua Dr. Maruri 1586 – Concórdia – SC</Text>
                <Text strong style={linkStyle}>
                  49 3441-4200
                </Text>
              </Space>
            </Col>

            <Col xs={0} sm={0} md={12} lg={12} xl={8} xxl={8} style={colStyle}>
              <Space direction="vertical" size={4}>
                <Text strong style={{ fontSize: 18, color: "#fff" }}>
                  Links Úteis
                </Text>

                <Link href="https://webmail.coperdia.com.br/" target="_blank" style={linkStyle}>
                  Webmail
                </Link>
                <Link href="http://www.coperdia.com.br/aplicativos/" target="_blank" style={linkStyle}>
                  Aplicativos Web
                </Link>
                <Link href="https://portal.coperdia.com.br/" target="_blank" style={linkStyle}>
                  Portal Copérdia
                </Link>
                <Link href="https://consentimentos.coperdia.com.br/" target="_blank" style={linkStyle}>
                  Consentimentos LGPD
                </Link>
              </Space>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} style={colStyle}>
              <Space direction="vertical" size={4}>
                <Space direction="vertical" size={4}>
                  <Text strong style={{ fontSize: 18, color: "#fff" }}>
                    Redes Sociais
                  </Text>
                  <Space size={10}>
                    <Link href="https://www.facebook.com/coperdia" target="_blank" style={socialStyle}>
                      <FacebookFilled />
                    </Link>
                    <Link href="https://www.instagram.com/coperdia.cooperativa/" target="_blank" style={socialStyle}>
                      <InstagramFilled />
                    </Link>
                    <Link href="https://wa.me/message/WKIFUWDNKN2FG1" target="_blank" style={socialStyle}>
                      <WhatsAppOutlined />
                    </Link>
                  </Space>
                </Space>

                <Text strong style={{ fontSize: 18, color: "#fff" }}>
                  Aplicativo
                </Text>
                <Space wrap size={15}>
                  <a
                    target="_blank"
                    href="https://apps.apple.com/br/app/cop%C3%A9rdia-colaborador/id6449134077?platform=iphone">
                    <img
                      src={"https://statics.coperdia.com.br/portal_colaborador/img/apple_store.png"}
                      width={140}
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                  <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=br.com.coperdia.app_colaborador">
                    <img
                      src={"https://statics.coperdia.com.br/portal_colaborador/img/google_store.png"}
                      width={140}
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                </Space>
              </Space>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} style={colStyle}></Col>
          </Row>
        </Col>
      </Row>
    </Footer>
  );
};
